<template>
<!-- Header Padrão para Todas as Telas Exceto algumas -->
<header class="group__header">
    <nav class="group__header__content">

        <a href="/" class="logo">
            <img :src="logoUrl" alt="Marca Onboard Entretenimento">
        </a>

        <!-- Menu Desktop -->
        <div class="navigation-desktop">
            <ul class="navigation__list">
                <li>
                    <div class="link">
                        <a v-bind:href="'/'"><i class="fa-solid fa-arrow-left"></i> Voltar para o site</a>
                    </div>
                </li>
                <li>
                    <div class="link">
                        <a v-bind:href="'/login'">Minha Conta</a>
                    </div>
                </li>
                <li v-if="!isLogged">
                    <div class="btn">
                        <a v-bind:href="'/register'" class="btn__cadastrar">Cadastrar</a>
                    </div>
                </li>
            </ul>
        </div>

        <!-- Menu Mobile -->
        <button @click="openNavigationMenuMobile" class="btn__navigation-mobile-open" type="button"> <!-- id="btn__navigation-mobile-open" -->
            <i class="fa-solid fa-bars"></i>
        </button>

        <div v-if="navigationMenuMobile" class="navigation-mobile"> <!-- id="navigation-mobile"-->
            <div class="navigation__header">
                <div v-if="isLogged" class="user">
                    <div class="user__avatar">
                        <i class="fa-solid fa-circle-user"></i>
                    </div>
                    <div class="user__name">{{ user.name }} {{ user.surName }}</div>
                </div>
                <button @click="closeNavigationMenuMobile" class="btn__navigation-mobile-close" type="button"> <!-- id="btn__navigation-mobile-close" -->
                    <i class="fa-solid fa-xmark"></i>
                </button>
            </div>
            <div class="navigation__body">
                <ul class="navigation__list">
                    <li>
                        <div class="link">
                            <a href="/"><i class="fa-solid fa-arrow-left"></i> Voltar para o site</a>
                        </div>
                    </li>
                    <li>
                        <div class="link">
                            <a href="/"><i class="fa-solid fa-user"></i> Minha Conta</a>
                        </div>
                    </li>
                    <li v-if="!isLogged">
                        <div class="btn">
                            <a v-bind:href="'/register'" class="btn__cadastrar">Cadastrar</a>
                        </div>
                    </li>
                </ul>
            </div>
        </div>

    </nav>
</header>
<div class="group__header__space"></div>
</template>

<script setup>
import logoUrl from '@/assets/logo.png'
import Auth from '@/utils/auth.js';
import { ref, onMounted } from 'vue';

const navigationMenuMobile = ref(false)
const isLogged = ref(false)
const user = ref(null)

async function openNavigationMenuMobile() {
    navigationMenuMobile.value = true;
}

async function closeNavigationMenuMobile() {
    navigationMenuMobile.value = false;
}

async function checkIfLogged() {
    isLogged.value = sessionStorage.getItem('user')
}

async function loadUser() {
    user.value = Auth.getCurrentUser()
}

onMounted(async () => {
    checkIfLogged()
    loadUser()
})
</script>


